module.exports = __webpack_public_path__ + "img/trash-solid.839d5189.svg";